module.exports = __webpack_public_path__ + "img/SEJ_Eventos_notificaciones_menu.c36882f5.svg";